import React from 'react';

import expand from '../../../images/expand.svg';

import { FOHImage } from '../../ingredients';

export const FOHExpandChatIcon = () => (
  <FOHImage source={{ uri: expand }} style={{ width: 24, height: 24 }} />
);
